"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _FormatExpirationDate = require("../../../../utils/FormatExpirationDate");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _text_input = require("../../text_input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ExpirationDateInput = function ExpirationDateInput(_ref) {
  var errors = _ref.errors,
    register = _ref.register;
  var error = false;
  var helperText = '';
  if (errors.expirationDate) {
    error = true;
    helperText = errors.expirationDate.message;
  }
  var handleExpirationDateInput = function handleExpirationDateInput(e) {
    var inputField = e.target;
    var inputValue = e.target.value;
    inputField.value = (0, _FormatExpirationDate.FormatExpirationDate)(inputValue);
  };
  var checkExpiredDate = function checkExpiredDate(date) {
    var expirationMonth = parseFloat(date.slice(0, 2));
    var currentMonth = new Date().getMonth() + 1;
    var expirationYear = parseFloat("20".concat(date.slice(-2)));
    var currentYear = new Date().getFullYear();
    var expiredCreditCardMessage = 'Your credit card is expired, please use another credit card.';
    if (expirationYear === currentYear) {
      if (expirationMonth < currentMonth) {
        return expiredCreditCardMessage;
      } else {
        return true;
      }
    } else if (expirationYear < currentYear) {
      return expiredCreditCardMessage;
    } else {
      return true;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    cypressClass: "credit-card-expiration-date",
    helperText: helperText,
    maxLength: 5,
    onChange: handleExpirationDateInput,
    error: error,
    type: "text",
    placeholder: "mm/yy",
    label: "Exp. Date (MM/YY)",
    name: "expirationDate",
    register: register({
      required: 'Missing Expiration Date',
      pattern: {
        value: /^(0[1-9]|1[012])\/[0-9]{2}/,
        message: 'Please make sure to follow this date format MM/YY'
      },
      validate: {
        isNotExpired: function isNotExpired(value) {
          return checkExpiredDate(value);
        }
      }
    })
  });
};
ExpirationDateInput.defaultProps = {
  errors: {},
  register: function register() {}
};
ExpirationDateInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ExpirationDateInput;